import React, { memo } from 'react'

export const RefreshTooltip = memo(() => (
    <div className="refresh-tooltip">
        Get new question
    </div>
))

export default RefreshTooltip